import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const prerenderedPath = document.documentElement.getAttribute("data-prerender-path");
const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if (container.hasChildNodes() && prerenderedPath === currentPath) {
  // Build-time prerendered HTML for this exact route: hydrate in place (DOM nodes are reused, no flash).
  window.__pmnPrerendered = true;
  ReactDOM.hydrateRoot(container, app);
} else {
  // Different route than the HTML was prerendered for (or nothing prerendered): client render from scratch.
  container.replaceChildren();
  ReactDOM.createRoot(container).render(app);
}
